export default __webpack_public_path__ + "static/media/ai3.4b0139c7.png";